import { RegionAvailable, REGIONS } from '@shared/services/language/registry';

export const validatePhoneByCountry = (phone: string, region: RegionAvailable): boolean =>
  new RegExp(REGIONS[region].phonePattern).test(phone.replace(/\s/g, ''));
